import { useMemo } from "react";

import Box from "@mui/material/Box";

import { useTranslation } from "react-i18next";
import StatisticsBox from "../../../../components/StatisticsBox";
import Tabs from "../../../../components/Tabs";

const CurrentMonth = ({ data }) => {
	const { t } = useTranslation();

	const tabs = useMemo(() => {
		return [
			{
				label: t("current_month"),
				content: (
					<Box sx={{ display: "flex", gap: "20px", flexWrap: "wrap" }}>
						<StatisticsBox
							title={t("cargos_entered")}
							value={data.entered}
							color="#000000"
						/>
						<StatisticsBox
							title={t("cargos_sold")}
							value={data.sold}
							color="#AE78D6"
						/>
						<StatisticsBox
							title={t("margin_label") + " (€)"}
							value={data.margin}
							color="#92D050"
						/>
						<StatisticsBox
							title={t("income") + " (€)"}
							value={data.income}
							color="#F07C00"
						/>
					</Box>
				),
			},
		];
	}, [data]);

	return <Tabs ariaLabel={t("current_month")} tabs={tabs} />;
};

export default CurrentMonth;
